import React, {useState} from "react";
import {CRITERIA_MODEL, SEARCH_MODEL, DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX} from "../../../../../components/table/Model/TableModel";
import {SearchByFilters, SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {useDispatch, useSelector} from "react-redux";
import {TABLES} from "../../../../../Apis/Tables";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import CustomChip from "../../../../../components/CustomChip";
import {status} from "../../../../../enums/statusEnum";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import {permissionObj} from "../../../../../Helpers/permission";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {
    ArrowRightIcon,
    DeleteIconsOptions,
    DetailsIconsOptions,
    IconAvatarTable,
    UpdateIconsOptions
} from "../../../../../components/buttons/IconButtons";
import TableFunction from "../../../../../components/table/TableFunction";
import CustomImageTable from "../../../../../components/CustomImageTable";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import { VISITOR_VIEWS_FROM } from "../../Guard/Model/Model";
import {visitorRulePayload} from "../Model/Model";
import {SEARCH_OPERATION_MODEL} from "../../../../Modals/Model/Model";
import {EMPTY_VALUES} from "../../../../../Apis/functions";

/**
 * @Email : kpozos@ibl.mx
 * @Author: karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param {Array<string>} selectedList - Currently selected invitation IDs (required).
 * @param {Function} setSelectedList - Function to update the selected invitations (required).
 * @param {Function} setCriteria - Function to update the search criteria for filters (required).
 * @param {Function} setBodyForExport - Function to define the export body payload (required).
 * @param {string} searchElement - ID or reference used for identifying the search input (required).
 * @param setSearchElement
 * @param {Array<Object>} finalArray - Array containing applied search filters (required).
 *
 * @param {Function} setDeleteModal - Function to open/close the delete confirmation modal.
 * @param {Function} goUpdate - Function to navigate to update or detail view of a visitor.
 * @param {boolean} modified - Flag to trigger data reload when changes occur.
 * @param {Function} setModified - Function to update the modified state.
 * @param {string} viewOrigin - Indicates the origin of the view (e.g., guard or admin).
 * @param {Function} setShowRequestAccessModal - Function to open the request access modal.
 * @param setIsAllChecked
 */

export const VisitorTabTableApp = ({
    selectedList,
    setSelectedList,
    setCriteria,
    searchElement,
    finalArray,
    setDeleteModal,
    goUpdate,
    modified,
    setModified,
    viewOrigin,
    setShowRequestAccessModal,
    setBodyForExport,
    setIsAllChecked,
    view,
}) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const tableId = "tbl_vtta_visitor"; // Set the table ID for identification
    const [results, setResults] = useState(null); // Store the search results
    const searchId = 'txt_vtta_search_visitor';
    const option = TABLES.VISITOR;
    const deletePermission = ((DEV || permission?.includes(permissionObj?.WEB_VISITOR_DELETE)) && viewOrigin !== VISITOR_VIEWS_FROM.VISITOR_GUARD);
    const leftPosition = deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('visitor_name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('email')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('telephone')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('document_id')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
        ];
    };

    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        <CustomImageTable image={IconAvatarTable} containerClass={"d-flex align-items-center"} text={item?.fullName}/>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.email}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.phoneNumber || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.documentId || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={t(status[item?.statusId])}
                                    borderColor={statusBorderColor[item?.statusId]}
                                    fontColor={statusFontColor[item?.statusId]}
                                    background={statusColor[item?.statusId]}
                                    variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body, // Return the generated table rows
            data: results?.content // Return the data associated with the rows
        };
    };

    const getActionsButtons = (item, index) => {
        return (
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`} // Unique menu ID for each contractor
            >
                {viewOrigin === VISITOR_VIEWS_FROM.VISITOR_GUARD ? (
                        <DropDownMenuItem
                            id={'btn_vtta_request_access_' + item?.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('request_access')}
                            click={() => {
                                setShowRequestAccessModal(true);
                                setSelectedList([item?.id]);
                            }}
                            icon={<ArrowRightIcon />}
                        />
                ) : (
                    <>
                        {(!DEV && !permission.includes(permissionObj?.WEB_VISITOR_UPDATE)) ? (
                            <DropDownMenuItem
                                id={'btn_vtta_details_' + item?.id}
                                index={index}
                                handleClose={handleClose}
                                name={t('details')}
                                click={() => {
                                    goUpdate(item, true);
                                }}
                                icon={<DetailsIconsOptions />}
                            />
                        ) : (DEV || permission.includes(permissionObj?.WEB_VISITOR_UPDATE)) && (
                                <DropDownMenuItem
                                    id={'btn_vtta_update_' + item?.id}
                                    index={index}
                                    handleClose={handleClose}
                                    name={t('update')}
                                    click={() => {
                                        goUpdate(item, false);
                                    }}
                                    icon={<UpdateIconsOptions />}
                                />
                            )
                        }

                        { deletePermission && (
                            <DropDownMenuItem
                                id={'btn_vtta_delete_' + item?.id}
                                index={index}
                                handleClose={handleClose}
                                name={t('delete')}
                                fontColor={'font-color-error-600'}
                                iconColor={"icon-color-error-code-600"}
                                click={() => {
                                    setSelectedList([item?.id]); // Set selected item ID for deletion
                                    setDeleteModal(true);
                                }}
                                icon={<DeleteIconsOptions />}
                            />
                        )}
                    </>
                )}
            </DropDownMenuProfile>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, view, model:option, key:searchElement })
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const { dataOption: _v, ...visitorRule } = visitorRulePayload(option);
        const finalTree =  CRITERIA_MODEL.set(finalArray);
        const rootGroup = {
            dataOption: SEARCH_OPERATION_MODEL.AND,
            rules: [visitorRule],
            subGroups: finalTree ? [finalTree] : [],
        };
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            rootGroup,
            viewType: VIEW_TYPE.LIST.viewType
        });
        setCriteria(body);
        dispatch(SearchByFilters({ option, body })).then(({ payload: { data: { data } } }) => {
            setResults(data);
        });
    };

    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { thead,tbody, t, handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage,
        openMenu, handleMenuToggle, handleClose } = TableFunction({
        getTbody: getTbody,
        getThead: getThead,
        selectedList,
        setSelectedList,
        data: results,
        labelRowsPerPage: 'visitors_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        searchElement,

        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    return {
        DEV,
        permission,
        setResults,
        option,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        deletePermission,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons
    };
};
